// Build a Google Maps directions URL to an address (prefers exact coords).
export function mapsDirUrl(a = {}) {
  const dest = a.lat && a.lng
    ? `${a.lat},${a.lng}`
    : [a.business, a.line1, a.city, a.postcode].filter(Boolean).join(", ");
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(dest)}`;
}

// Build a clickable tel: link from a phone number.
export function telHref(phone = "") {
  return `tel:${String(phone).replace(/[^+\d]/g, "")}`;
}
